<template>
<div>
    <div v-if="isLoading" class="loading-overlay2">
        <div class="">
            <svg xmlns="http://www.w3.org/2000/svg" style="margin: auto; background: none; display: block;" width="50px" height="50px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                <circle cx="50" cy="50" fill="none" stroke="#e9ff86" stroke-width="10" r="35" stroke-dasharray="165 57">
                    <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="0.5s" values="0 50 50;360 50 50" keyTimes="0;1" />
                </circle>
            </svg>
        </div>
    </div>
    <section>
        <div class="top-nav-div">
            <div class="top-nav-elements">
                <a href="#" class="link-block-42 w-inline-block"><img sizes="(max-width: 1000px) 100vw, 1000px" srcset="@/assets/images/NewSelf_Logo-p-500.webp 500w, @/assets/images/NewSelf_Logo-p-800.webp 800w, @/assets/images/NewSelf_Logo.webp 1000w" alt="" src="@/assets/images/NewSelf_Logo.webp" loading="lazy" class="image-294"></a>
                <div class="form-nav-div" :class="{ 'has-back-button': active_el > 1 }">
                    <a href="#" @click.prevent="GoBack()" class="back-link w-inline-block" :style="{ visibility: active_el === 1 ? 'hidden' : 'visible' }">
                        <div class="text-block-507">&lt;-</div>
                    </a>
                    <div class="form-progress-div">
                        <div>
                            <div class="text-block-508">Pre-Qualify</div>
                        </div>
                        <div class="form-precent-div">
                            <div class="text-block-509"><strong>2. Choose Meds</strong></div>
                        </div>
                    </div>
                    <div class="back-link-spacer"></div>
                </div>
                <div class="div-block-1442">
                </div>
            </div>
        </div>
    </section>
    <section class="afterreport_section" v-if="section == 1">
        <div class="questions-div">
            <div class="question-container" v-if="active_el === 1">
                <div class="question-div-2">
                    <div class="text-block-513 hq">Do you currently take weight loss medication?</div>
                    <div class="felix-form-block w-form">
                        <form id="email-form" name="email-form" data-name="Email Form" method="get" data-wf-page-id="6752fce89f545be422ca0525" data-wf-element-id="3416fdec-b089-e392-c3b8-07826e71b460">
                            <div class="div-block-1487">
                                <a href="#" class="button-68 w-button checkbox-field-Yes" @click.prevent="setValue('currentlyTakingGLP', 'Yes')">YES</a>
                                <a href="#" class="button-68 w-button checkbox-field-Yes" @click.prevent="setValue('currentlyTakingGLP', 'No')">NO</a>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div class="question-container" v-if="active_el == 2">
                <div class="question-div-2">
                    <div class="text-block-513 hq">What weight loss drugs are you currently prescribed?</div>
                    <div class="felix-form-block w-form">
                        <form id="email-form" name="email-form" data-name="Email Form" method="get" data-wf-page-id="6752fce89f545be422ca0525" data-wf-element-id="3416fdec-b089-e392-c3b8-07826e71b460">
                            <div class="div-block-1487">
                                <div class="rx_option_div">
                                    <a href="#" class="link-block-76 w-inline-block" @click.prevent="setValue('currentGLPMed', 'Semaglutide')">
                                        <div class="text-block-1137" style="font-weight: normal;">Semaglutide</div>
                                    </a>
                                     <a href="#" class="link-block-76 w-inline-block" @click.prevent="setValue('currentGLPMed', 'Ozempic')">
                                        <div class="text-block-1137" style="font-weight: normal;">Ozempic</div>
                                    </a>
                                     <a href="#" class="link-block-76 w-inline-block" @click.prevent="setValue('currentGLPMed', 'Wegovy')">
                                        <div class="text-block-1137" style="font-weight: normal;">Wegovy</div>
                                    </a>
                                    <a href="#" class="link-block-76 w-inline-block" @click.prevent="setValue('currentGLPMed', 'Tirzepatide')">
                                        <div class="text-block-1137" style="font-weight: normal;">Tirzepatide</div>
                                    </a>
                                    <a href="#" class="link-block-76 w-inline-block" @click.prevent="setValue('currentGLPMed', 'Mounjaro')">
                                        <div class="text-block-1137" style="font-weight: normal;">Mounjaro</div>
                                    </a>
                                    <a href="#" class="link-block-76 w-inline-block" @click.prevent="setValue('currentGLPMed', 'Zepbound')">
                                        <div class="text-block-1137" style="font-weight: normal;">Zepbound</div>
                                    </a>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div class="question-container" v-if="active_el == 3">
                <div class="question-div-2">
                    <div class="text-block-513 hq">What {{ planOptions.currentGLPMed }} dosage are you currently taking?</div>
                    <div class="felix-form-block w-form">
                        <form id="email-form" name="email-form" @submit.prevent="setPlan()">
                            <select required class="select-field-9 w-select" v-model="planOptions.currentDose">
                                <option value="">Select dose...</option>
                                <option v-for="d in doseOption" :key="d" :value="d">{{ d }} mg</option>
                            </select>
                            <input type="submit" data-wait="Please wait..." class="form-button w-button" value="Next -&gt;">
                        </form>
                    </div>
                    <div class="div-block-1941">
                        <div class="text-block-1127"><span class="text-span-240">Same Price. All Dosage
                                Levels.</span><br>No Hidden Fees. Everything Included.</div>
                        <div class="treatsum_deetsdiv form">
                            <div class="treatsum_inclusionsdiv form">
                                <div class="treatsum_perkdiv"><img src="@/assets/images/icon_board-copy.svg" loading="lazy" alt="" class="image-474">
                                    <div class="text-block-1041">Initial Telehealth Visit</div>
                                </div>
                                <div class="treatsum_perkdiv"><img src="@/assets/images/icon_meds-copy.svg" loading="lazy" alt="" class="image-474">
                                    <div class="text-block-1041">Prescription + Medication</div>
                                </div>
                            </div>
                            <div class="treatsum_inclusionsdiv form">
                                <div class="treatsum_perkdiv"><img src="@/assets/images/icon_support.svg" loading="lazy" alt="" class="image-474">
                                    <div class="text-block-1041">24/7 Support</div>
                                </div>
                                <div class="treatsum_perkdiv"><img src="@/assets/images/icon_appointment.svg" loading="lazy" alt="" class="image-474">
                                    <div class="text-block-1041">Monthly check-in</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div class="question-container" v-if="active_el == 4">
                <div class="question-div-2">
                    <div class="text-block-513 hq recommended">Here&#x27;s what we recommend:</div>
                    <div class="div-block-1681"><img loading="lazy" src="@/assets/images/steps_doc1.webp" alt="" class="image-382">
                        <p class="paragraph-127">Your healthcare practicioner will review your treatment with you before it&#x27;s finalized.</p>
                    </div>
                    <div class="telehealth-button-div" style="padding-left:0px;">
                        <div class="text-block-513 hq" style="font-size: 18px;">Click to choose:</div>
                    </div>
                    <div class="felix-form-block w-form" style="margin-top:0px;">
                        <form id="email-form" name="email-form" data-name="Email Form" method="get" data-wf-page-id="66eaed7e459c67142b9f9bb5" data-wf-element-id="3abb582e-8853-a9ef-0290-ed0a78b101d0">
                            <div class="program-choice-div products">
                                <a href="#" class="link-block-48 sema w-inline-block" @click.prevent="setValue('selectedGLPMed', 'Semaglutide')">
                                    <img loading="lazy" src="@/assets/images/klarna-badge.webp" alt="Klarna" class="klarna-badge">
                                    <div class="div-block-1643 sema">
                                        <div class="text-block-719"><span class="text-span-174 sema">Most Popular</span></div><img loading="lazy" src="" alt="" class="image-360">
                                        <div class="form-product-2">Semaglutide</div>
                                        <div class="text-block-724">COMPOUND W/ B12</div>
                                        <p class="paragraph-126 form"></p>
                                        <div class="form-price-div felix">
                                            <div class="div-block-1697">
                                                <div class="div-block-1678"><img loading="lazy" src="@/assets/images/icon_check_LGreenBlkoutline.svg" alt="" class="image-380">
                                                    <div class="text-block-712">16% Avg. Weight Loss</div>
                                                </div>
                                                <div class="div-block-1678"><img loading="lazy" src="@/assets/images/icon_check_LGreenBlkoutline.svg" alt="" class="image-380">
                                                    <div class="text-block-712">No insurance required</div>
                                                </div>
                                                <div class="div-block-1678"><img loading="lazy" src="@/assets/images/icon_check_LGreenBlkoutline.svg" alt="" class="image-380">
                                                    <div class="text-block-712">Express Shipping</div>
                                                </div>
                                                <div class="select-plan-btn sema" role="button" @click.prevent.stop="setValue('selectedGLPMed', 'Semaglutide')">Get Started</div>
                                            </div>
                                            <div class="form-price felix">
                                                <div class="text-block-696">Starting at</div>
                                                <div class="amount price-amt" :class="{ 'price-loading': !pricesReady }">
                                                    <div class="text-block-728">$</div>
                                                    <div class="text-block-714">{{ lowestSemaPrice.dollars }}</div>
                                                    <div class="text-block-728 cents">{{ lowestSemaPrice.cents }}</div>
                                                </div>
                                                <div class="text-block-722">a month</div>
                                            </div>
                                        </div>
                                        <div class="div-block-1645"><img loading="lazy" src="@/assets/images/1_icon_Check.svg" alt="" class="image-370">
                                            <div class="text-block-713">A once-weekly injection.</div>
                                        </div>
                                        <div class="div-block-1645"><img loading="lazy" src="@/assets/images/1_icon_Check.svg" alt="" class="image-370">
                                            <div class="text-block-713">Most Prescribed GLP-1 </div>
                                        </div>
                                        <div class="div-block-1645"><img loading="lazy" src="@/assets/images/1_icon_Check.svg" alt="" class="image-370">
                                            <div class="text-block-713">Produced in the USA.</div>
                                        </div>
                                        <div class="select-plan-btn-desktop sema" role="button" @click.prevent.stop="setValue('selectedGLPMed', 'Semaglutide')">Get Started</div>
                                    </div>
                                </a>

                                <a href="#" class="link-block-48 tirz w-inline-block" @click.prevent="setValue('selectedGLPMed', 'Tirzepatide')">
                                    <img loading="lazy" src="@/assets/images/klarna-badge.webp" alt="Klarna" class="klarna-badge">
                                    <div class="div-block-1643 tirz">
                                        <div class="text-block-719"><span class="text-span-174 tirz">Most Effective</span></div>
                                        <div class="form-product-2">Tirzepatide</div>
                                        <div class="text-block-724">COMPOUND W/ B6</div>
                                        <p class="paragraph-126 form"></p>
                                        <div class="div-block-1645"><img loading="lazy" src="@/assets/images/1_icon_Check.svg" alt="" class="image-370">
                                            <div class="text-block-713">A once-weekly injection.</div>
                                        </div>
                                        <div class="div-block-1645"><img loading="lazy" src="@/assets/images/1_icon_Check.svg" alt="" class="image-370">
                                            <div class="text-block-713">Most Effective GLP-1</div>
                                        </div>
                                        <div class="div-block-1645"><img loading="lazy" src="@/assets/images/1_icon_Check.svg" alt="" class="image-370">
                                            <div class="text-block-713">Produced in the USA.</div>
                                        </div>
                                    </div>
                                    <div class="form-price-div felix">
                                        <div class="div-block-1697">
                                            <div class="div-block-1678"><img loading="lazy" src="@/assets/images/icon_check_LGreenBlkoutline.svg" alt="" class="image-380">
                                                <div class="text-block-712">22% Avg. Weight Loss</div>
                                            </div>
                                            <div class="div-block-1678"><img loading="lazy" src="@/assets/images/icon_check_LGreenBlkoutline.svg" alt="" class="image-380">
                                                <div class="text-block-712">No insurance required</div>
                                            </div>
                                            <div class="div-block-1678"><img loading="lazy" src="@/assets/images/icon_check_LGreenBlkoutline.svg" alt="" class="image-380">
                                                <div class="text-block-712">Express Shipping</div>
                                            </div>
                                            <div class="select-plan-btn tirz" role="button" @click.prevent.stop="setValue('selectedGLPMed', 'Tirzepatide')">Get Started</div>
                                        </div>
                                        <div class="form-price felix">
                                            <div class="text-block-696">Starting at</div>
                                            <div class="amount price-amt" :class="{ 'price-loading': !pricesReady }">
                                                <div class="text-block-728">$</div>
                                                <div class="text-block-714">{{ lowestTirzPrice.dollars }}</div>
                                                <div class="text-block-728 cents">{{ lowestTirzPrice.cents }}</div>
                                            </div>
                                            <div class="text-block-722">a month</div>
                                        </div>
                                    </div>
                                    <div class="select-plan-btn-desktop tirz" role="button" @click.prevent.stop="setValue('selectedGLPMed', 'Tirzepatide')">Get Started</div>
                                </a>
                            </div>

                        </form>
                        <div class="w-form-done">
                            <div>Thank you! Your submission has been received!</div>
                        </div>
                        <div class="w-form-fail">
                            <div>Oops! Something went wrong while submitting the form.</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <div v-if="section == 2">
        <section class="checkout-section" v-if="section_2_active_el == 1">
            <div class="checkoutb_wrap">
                <div class="checkoutb_div">
                    <div class="upsell_wrap">
                        <div class="upsell-header-div">
                            <div class="text-block-1181">Improve Results.<br>Eliminate Side Effects.</div>
                            <p class="paragraph-15-14">Supercharge your results with instant nausea relief for less than insurance.</p>
                        </div>
                        <div class="upsell-box">
                                <div class="upsell_boxtag">Weight Loss</div>
                                <div class="choice-main-div">
                                    <div class="choice-box-flex">
                                        <div class="choice-box-div-1">
                                            <div class="upsell_productinfo_div">
                                                <div class="choice-img-div"><img src="@/assets/images/NS_Zorfran-SQ.webp" loading="lazy" alt="" class="upsell_product_img"></div>
                                                <div class="upsell-text-side-div">
                                                    <div class="upsell_productname_pricediv">
                                                        <div class="progname-div">
                                                            <div class="upsell-procuctname">GLP Anti-Nausea</div>
                                                            <div class="upsell_productsub_div"><img loading="lazy" src="@/assets/images/icon_-RX-black.svg" alt="" class="image-596">
                                                                <div class="upsell-product-subtext">Generic Zofran</div>
                                                            </div>
                                                        </div>
                                                        <div class="upsell-price-main-div">
                                                            <div class="upsell-prices-div">
                                                                <div class="old-price">
                                                                    <div class="item-price-div">
                                                                        <div class="dollar-sign-2">$</div>
                                                                        <div class="price-2 old upsell">74</div><img width="69" loading="lazy" alt="" src="@/assets/images/68010e3d8de415a9f84337e2_discount x-01.webp" class="x_img _2digit">
                                                                    </div>
                                                                </div>
                                                                <div class="program-amount">
                                                                    <div class="text-block-728">$</div>
                                                                    <div class="program-price">19</div>
                                                                    <div>
                                                                        <div class="text-block-1451">.97</div>
                                                                        <div class="text-block-1452">/mo</div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="upsell_details_div">
                                                <p class="upsell_paragraph">Ondansetron (Zofran) instantly relieves nausea, helping you stay comfortable and consistent with your GLP-1 treatments.</p>
                                                <div class="upsell_benefits_div">
                                                    <div class="upsell_bullets_div shorter">
                                                    <div class="div-block-1948 recos"><img width="75.5" loading="lazy" alt="" src="@/assets/images/icon_Check-black1.svg" class="upsell_bullet_img">
                                                        <div class="upsell-bullet-text no-highlight">Instant Nausea Relief</div>
                                                    </div>
                                                    
                                                    </div>
                                                    <div class="upsell_bullets_div">
                                                    <div class="div-block-1948"><img width="75.5" loading="lazy" alt="" src="@/assets/images/icon_Check-black1.svg" class="upsell_bullet_img">
                                                        <div class="upsell-bullet-text no-highlight">Eliminate side effects</div>
                                                    </div>
                                                    
                                                    </div>
                                                </div>
                                            </div>
                                            
                                            <div class="upsell_buttons-stack">
                                                <a href="#" @click.prevent="setMedSelected('Nausea')" class="upsell-buy-button w-button">ADD TO CART</a>
                                                <div class="upsell-buttons-flex hide-buttons">
                                                    <a href="#" class="upsell_learnbutton w-button">Learn More</a>
                                                    <a href="#" class="link-block-95 w-inline-block">
                                                        <div class="div-block-2134"><img src="images/icon_faq.svg" loading="lazy" alt="" class="image-620">
                                                            <div>Ask a Question</div>
                                                        </div>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        <div class="upsell-button-div">
                            <a href="#" @click.prevent="moveToNext()" class="button-113 w-button"><strong>&quot;I&#x27;m Not Interested in Eliminating My
                                    Side Effects&quot;</strong> <span class="text-span-254">-&gt;</span></a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- step 2 of the page -->

    </div>
</div>
</template>

<script>
import {
    mapGetters,
    mapActions
} from 'vuex';

import {
    getProductsById
} from '@/utils/productData';
import { offerQuery } from '@/utils/freeNadLifeOffer.js';

export default {
    components: {

    },
    data() {
        return {
            baseUrl: process.env.VUE_APP_API_ENDPOINT,
            pricingConfig: JSON.parse(process.env.VUE_APP_PRICING || '{"semaglutide":{"monthly":{"first":194.97,"regular":194.97},"terms":{"3":449.91,"6":767.82,"12":1199.64}},"tirzepatide":{"monthly":{"first":274.97,"regular":274.97},"terms":{"3":644.91,"6":1129.08,"12":2099.64}}}'),
            // Product ObjectIds used BOTH to build the cart and to fetch live prices below.
            // These were already hardcoded inline for cart creation; centralized here so there's
            // one source. NOTE: env-specific — if they ever differ per env, source from env/backend.
            productIds: {
                Semaglutide: '675ac4cb6bf102c19ec3afec',
                Tirzepatide: '675ac4cb6bf102c19ec3afe9',
            },
            // Live PROMO plan prices/ids per product, keyed by term. Empty until
            // loadPlans resolves; on failure they stay empty so "Starting at" falls back to the
            // env pricingConfig. isPromo to match the checkoutWeightLoss page this flow leads
            // to — otherwise the price would jump between the two screens.
            apiPlansSema: {},
            apiPlansTirz: {},
            // False until the live prices resolve — gates the shimmer skeleton so the env
            // fallback price doesn't flash before the API price loads.
            pricesReady: false,
            semaClassMeds: ['Semaglutide', 'Ozempic', 'Wegovy'],
            tirzClassMeds: ['Tirzepatide', 'Mounjaro', 'Zepbound'],
            showMessage: false,
            active_el: 1,
            isLoading: false,
            cartId: '',
            section: 1,
            section_2_active_el: 1,
            planOptions: {
                currentlyTakingGLP: '',
                currentGLPMed: '',
                selectedGLPMed: '',
                selectedPlanTerms: '',
                currentDose: ''
            }
        }
    },
    computed: {
        ...mapGetters(['user']),
        lowestSemaPrice() {
            // Live annual (12-term) price when loaded, else env fallback. "Starting at" = annual / 12.
            const total = this.apiPlansSema[12]?.price ?? this.pricingConfig.semaglutide.terms['12']
            const monthly = total / 12
            return { dollars: Math.floor(monthly), cents: Math.round((monthly % 1) * 100).toString().padStart(2, '0') }
        },
        lowestTirzPrice() {
            const total = this.apiPlansTirz[12]?.price ?? this.pricingConfig.tirzepatide.terms['12']
            const monthly = total / 12
            return { dollars: Math.floor(monthly), cents: Math.round((monthly % 1) * 100).toString().padStart(2, '0') }
        },
        doseOption() {
            if (this.semaClassMeds.includes(this.planOptions.currentGLPMed)) {
                return [0.25, 0.5, 1, 2, 2.5];
            }
            return [2.5, 5, 7.5, 10, 12.5, 15];
        },
        bmi() {
            const heightInInches = parseFloat(this.user.height_inch);
            const weightInPounds = parseFloat(this.user.weight);
            return (weightInPounds / (heightInInches * heightInInches)) * 703;
        }
    },
    created() {
        try {
            const raw = localStorage.getItem('preform_glp_data');
            if (raw) {
                const data = JSON.parse(raw);
                if (data && data.currentlyTakingGLP === 'Yes') {
                    this.planOptions.currentlyTakingGLP = 'Yes';
                    const allMeds = [...this.semaClassMeds, ...this.tirzClassMeds];
                    if (data.currentGLPMed && allMeds.includes(data.currentGLPMed)) {
                        this.planOptions.currentGLPMed = data.currentGLPMed;
                        this.active_el = 3;
                    } else if (data.currentGLPMed) {
                        this.planOptions.currentGLPMed = data.currentGLPMed;
                        this.active_el = 4;
                    } else {
                        this.active_el = 2;
                    }
                }
                localStorage.removeItem('preform_glp_data');
            }
        } catch (e) {
            // ignore — disabled storage or malformed JSON
        }
        // Fetch live prices in the background; "Starting at" updates reactively once they load.
        this.loadPlans();
    },
    methods: {
        ...mapActions([
            'setCartVisibility',
            'clearCart',
        ]),
        // Pull live PROMO prices for BOTH products so the "Starting at" figures
        // match what the checkout charges. Same get-all-plans call the checkout pages use, once
        // per product (this page has no cart yet, so it can't read a single cart product).
        async loadPlans() {
            await Promise.all([
                this.fetchPlansFor(this.productIds.Semaglutide, 'apiPlansSema'),
                this.fetchPlansFor(this.productIds.Tirzepatide, 'apiPlansTirz'),
            ]);
            // Reveal prices whether the fetch succeeded (live) or fell back to env — never leave
            // the skeleton shimmering forever.
            this.pricesReady = true;
        },
        async fetchPlansFor(productId, target) {
            try {
                if (!productId) return;
                const response = await this.$axios.get(`${this.baseUrl}/api/get-all-plans`, {
                    params: { isPromo: true, productId }
                });
                if (response.data.status === 'success' && Array.isArray(response.data.plans)) {
                    const plans = {};
                    response.data.plans.forEach((plan) => {
                        if (plan && plan.terms != null && plan.price != null) {
                            plans[Number(plan.terms)] = { id: plan.id, price: Number(plan.price) };
                        }
                    });
                    this[target] = plans;
                }
            } catch (error) {
                console.error('Error loading plans:', error);
            }
        },
        setPlan() {

            if (this.planOptions.currentDose == null) {
                return false;
            }
            this.planOptions.selectedGLPMed = this.planOptions.currentGLPMed;
            if (this.semaClassMeds.includes(this.planOptions.currentGLPMed)) {
                this.moveNext(1);
            } else {
                this.moveToCheckout();
            }
        },
        async setValue(field, value) {
            this.planOptions[field] = value;
            if (field === 'currentlyTakingGLP' && value === 'No') {
                if (this.bmi < 20) {
                    this.$router.push({
                        name: 'leadDisqualified',
                        query: {
                            message: "We cannot proceed since your BMI is less than 20. "
                        }
                    });
                    this.addTagForDisqualify();
                    return false;
                }

                this.moveNext(3);
            } else if (field === 'selectedGLPMed') {
                this.moveToCheckout();
            } else {
                this.moveNext(1);
            }
        },
        addTagForDisqualify() {
            this.$axios.get(`${this.baseUrl}/forms/add-disqualify`);
        },
        moveToSorryPage() {
            this.$router.push("/sorry?message=We're truly sorry to see you go. We'll notify you as soon as the doses are available.")
        },
        async moveToCheckout() {
            try{
                await this.clearCart();
            }catch(error){
                console.log(error)
            }
            
            let productId = this.tirzClassMeds.includes(this.planOptions.selectedGLPMed) ? this.productIds.Tirzepatide : this.productIds.Semaglutide
            let product = await getProductsById(productId);
            let plan = product[0]
            const cartItem = {
                id: plan.id,
                name: plan.name,
                category: plan.category.primary,
                price: plan.pricing.retail_price,
                retail_price: plan.pricing.retail_price,
                subheader: 'Compound Medication',
                sku: plan.sku,
                stripe_id: plan.stripe_id,
                quantity: 1, // Ensure it's a valid number
                image: `https://newselfrx.s3.us-east-1.amazonaws.com/public/assets/product_image/webp/${plan.image_pre_text}/1.webp`,
                is_addon: false,
            };
            
            // Fire add_to_cart tracking event
            try {
                if (window.tracking) {
                    // No event_value here: no payment term is chosen yet, so no cart
                    // total exists. The checkout reports the plan price once it does.
                    window.tracking.event('add_to_cart', {
                        funnel_step: 14,
                        currency: 'USD',
                        product_id: cartItem.id,
                        product_name: cartItem.name,
                        plan_id: cartItem.stripe_id,
                        quantity: 1,
                        form: "glp_signup"
                    });
                }
            } catch(error) {
                console.log(error)
            }

            this.saveCart(cartItem);
        },
        GoBack() {
            if (this.section === 2) {
                if (this.section_2_active_el === 1) {
                    this.section = 1;

                    if (this.planOptions.currentlyTakingGLP === 'No') {
                        this.active_el = 1;
                        this.planOptions.selectedGLPMed = '';
                    } else {
                        this.active_el = 4;
                    }
                    return;
                }

                if (this.section_2_active_el > 1) {
                    this.section_2_active_el--;
                    return;
                }
            }

            if (this.section === 1 && this.active_el > 1) {

                if (this.active_el === 3 && this.planOptions.currentlyTakingGLP === 'No') {
                    this.active_el = 1;
                    this.planOptions.currentGLPMed = '';
                    this.planOptions.currentDose = '';
                    return;
                }

                if (this.active_el === 4) {
                    if (this.planOptions.currentlyTakingGLP === 'Yes') {
                        this.active_el = 3;
                    } else {
                        this.active_el = 1;
                    }
                    return;
                }

                if (this.active_el === 5) {
                    this.active_el = 4;
                    this.planOptions.selectedGLPMed = '';
                    return;
                }

                this.active_el--;

                if (this.fieldErrors) {
                    this.fieldErrors = {};
                }

                if (this.active_el === 1) {
                    this.planOptions.currentlyTakingGLP = '';
                    this.planOptions.currentGLPMed = '';
                    this.planOptions.currentDose = '';
                    this.planOptions.selectedGLPMed = '';
                } else if (this.active_el === 2) {
                    this.planOptions.currentGLPMed = '';
                    this.planOptions.currentDose = '';
                }
            }
        },
        setMedSelected(value) {
            this.selectedOption = value;
            const cartItem = {
                id: "684b25127fc4b1cb8576f02d",
                name: "GLP Anti-Nausea",
                category: "Weight",
                price: 19.97,
                retail_price: 19.97,
                subheader: 'Compound Medication',
                sku: 185,
                stripe_id: "nausia_278928",
                quantity: 1, // Ensure it's a valid number
                image: `https://newselfrx.s3.us-east-1.amazonaws.com/public/assets/product_image/webp/zofran/1.webp`,
                is_addon: true,
            };
            this.$store.dispatch('addToCart', cartItem);
            this.setCartVisibility(false);
            this.addBundleAndMove();
        },
        getImage() {
            if (this.tirzClassMeds.includes(this.planOptions.selectedGLPMed)) {
                return "https://newselfrx.s3.us-east-1.amazonaws.com/public/assets/product_image/webp/tirzepatide/1.webp"
            } else {
                return "https://newselfrx.s3.us-east-1.amazonaws.com/public/assets/product_image/webp/semaglutide/1.webp"
            }
        },
        moveToNext() {
            this.addBundleAndMove();
        },
        addBundleAndMove() {
            this.$router.push({
                name: 'checkoutWeightLoss',
                params: {
                    cart_id: this.cartId
                },
                // A lander's offer link (?offer=…&nad=…) rides along to the checkout.
                query: offerQuery(this.$route.query)
            });
        },
        saveCart(cartItem) {
            this.isLoading = true;
            let postData = {
                ...cartItem,
                sema_offer: this.$store.getters.offerSema,
                tir_offer: this.$store.getters.offerTir,
                currentGLPMed: this.planOptions.currentGLPMed,
                currentDose: this.planOptions.currentDose,
            };
            this.$axios.post(`${this.baseUrl}/api/save-cart`, postData, {
                    headers: {
                        'Content-Type': 'application/json',
                    }
                })
                .then(response => {
                    if (response.data.status === 'success') {
                        this.cartId = response.data.id
                        this.$store.dispatch('addToCart', cartItem);
                        this.setCartVisibility(false);
                        this.addBundleAndMove();
                        window.scrollTo(0, 0);
                        this.isLoading = false;
                    
                    } else {
                        alert("Unexpected response:", response.data);
                    }
                })
                .catch(error => {
                    alert("Error saving cart:", error.message);
                });

        },
        moveNext(step) {
            console.log('offer from store ', this.$store.getters.weightLossOffer)
            this.active_el = this.active_el + step;

        },

    }
}
</script>

<style scoped>
/* Price loading skeleton — hides the env fallback price until the live plan price loads.
   No `display` override here: .price-amt sits on the .amount wrapper, which webflow sets to
   `display: flex` so "$ / 119 / 97" sit on one line. A scoped .price-amt rule outspecifies
   .amount, so setting display here stacks the three parts vertically. */
.price-loading {
    color: transparent !important;
    position: relative;
    border-radius: 4px;
    overflow: hidden;
    min-width: 3ch;
}
.price-loading::after {
    content: "";
    position: absolute;
    inset: 0;
    background: linear-gradient(90deg, #e9e9e9 25%, #f5f5f5 50%, #e9e9e9 75%);
    background-size: 200% 100%;
    animation: price-shimmer 1.1s ease-in-out infinite;
}
@keyframes price-shimmer {
    0% { background-position: 200% 0; }
    100% { background-position: -200% 0; }
}
.hidedesk{
    display: none;
}
@media screen and (max-width: 479px) {
    .recommended {
        margin-top: -10% !important;
    }
    .hidedesk{
        display: block;
    }
    .felix-form-block {
        margin-top: 0%;
    }
    .button-113 {
        padding-left: 0px; 
        padding-right: 0px; 
    }
}


.checkbox-field-Yes {
    background-position: 100%;
    background-repeat: no-repeat;
    background-size: 10%;
    border: 1px solid #000;
    border-radius: 6px;
    margin-bottom: 15px;
}

.button-model-yes-no {
    display: flex;
    justify-content: space-around;
    gap: 15%;
    width: 100%
}

.questions-div.form-rep {
    padding-top: 30px;
    padding-bottom: 50px;
    max-width: 100%;
    padding-left: 20px;
    padding-right: 20px;
}

.button-107 {
    width: 45%
}

@media screen and (max-width: 479px) {
    .text-block-513.hq {
        font-size: 25px;
        line-height: 36px;
    }

    .text-block-1127 {
        font-size: 18px;
        font-weight: 400;
        line-height: 26px;
    }

    .text-span-240 {
        font-size: 20px;
    }
}

/* Spacer to balance the back button and keep progress bar centered */
.back-link-spacer {
    width: 44px;
    flex-shrink: 0;
}

/* Center the content section */
.questions-div {
    margin: 0 auto !important;
}

/* Make the medication options match the nav width */
.rx_option_div {
    width: 100% !important;
    max-width: 580px !important;
    display: flex !important;
    flex-direction: column !important;
    gap: 15px !important;
}

.rx_option_div a.link-block-76 {
    width: 100% !important;
}

/* Fixed centered progress bar - LARGE DESKTOP ONLY */
@media screen and (min-width: 1025px) {
    .form-nav-div {
        position: fixed !important;
        top: 15px !important;
        left: 50% !important;
        transform: translateX(-50%) !important;
        min-width: 500px !important;
        max-width: calc(100% - 40px) !important;
        z-index: 100 !important;
    }

    .form-nav-div.has-back-button {
        transform: translateX(calc(-50% + 25px)) !important;
    }
}

/* Mobile/Tablet header layout */
@media screen and (max-width: 1024px) {
    .top-nav-div {
        width: 100% !important;
    }

    .top-nav-elements {
        display: grid !important;
        grid-template-columns: 1fr auto !important;
        align-items: center !important;
        width: 100% !important;
        padding: 1px 1px !important;
        gap: 10px !important;
    }

    .link-block-42 {
        display: block !important;
        grid-column: 1 !important;
        justify-self: start !important;
    }

    .link-block-42 .image-294 {
        max-width: 90px !important;
        height: auto !important;
        display: block !important;
    }

    .form-nav-div {
        grid-column: 2 !important;
        justify-self: end !important;
        display: flex !important;
        align-items: center !important;
    }

    .form-progress-div {
        display: none !important;
    }

    .div-block-1442 {
        display: none !important;
    }

    .back-link-spacer {
        display: none !important;
    }

    .back-link {
        margin: 0 !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        padding: 8px !important;
    }

    .text-block-507 {
        font-size: 28px !important;
        line-height: 1 !important;
    }
}

.link-block-48 {
    position: relative;
}

.klarna-badge {
    position: absolute;
    top: 155px;
    right: 12px;
    bottom: auto;
    width: 60px;
    height: auto;
    border-radius: 4px;
    z-index: 2;
}

.select-plan-btn-desktop {
    display: block;
    width: 100%;
    margin: 18px 0 0;
    padding: 14px 20px;
    border-radius: 12px;
    background-color: var(--light-green, #e9ff86);
    color: var(--black, #000);
    font-family: var(--arrow), Manrope, sans-serif;
    font-size: 16px;
    font-weight: 700;
    text-align: center;
    cursor: pointer;
    transition: background-color 0.15s, transform 0.1s;
    user-select: none;
    box-sizing: border-box;
}

.select-plan-btn-desktop:hover {
    background-color: var(--light-blue, #c8e7f9);
}

.select-plan-btn-desktop:active {
    transform: scale(0.98);
}

@media screen and (max-width: 479px) {
    .link-block-48 {
        padding-bottom: 42px;
    }

    .form-price.felix {
        margin-top: 40px;
    }

    .klarna-badge {
        top: auto;
        bottom: 4px;
        right: 4px;
        width: 50px;
    }

    .select-plan-btn-desktop {
        display: none;
    }
}

/* Bump dose dropdown font up to match the rest of the form */
.select-field-9 {
    font-size: 18px !important;
    line-height: 24px !important;
}

.select-field-9 option {
    font-size: 18px;
}

.select-plan-btn {
    display: block;
    margin: 18px auto 0;
    padding: 14px 20px;
    border-radius: 12px;
    background-color: var(--light-green, #e9ff86);
    color: var(--black, #000);
    font-family: var(--arrow), Manrope, sans-serif;
    font-size: 16px;
    font-weight: 700;
    text-align: center;
    cursor: pointer;
    transition: background-color 0.15s, transform 0.1s;
    user-select: none;
}

.select-plan-btn:hover {
    background-color: var(--light-blue, #c8e7f9);
}

.select-plan-btn:active {
    transform: scale(0.98);
}

@media screen and (max-width: 479px) {
    .select-plan-btn {
        font-size: 15px;
        padding: 12px 16px;
        margin-top: 14px;
    }
}

@media screen and (max-width: 380px) {
    .select-plan-btn {
        width: 70%;
    }
}
</style>
